import { addDocument, getCollection, getDocumentData } from '../firebase';

export { getAlbum, getArtistAlbums, getReview, saveReview, signInWithFacebook, signInWithGoogle, uploadImage  } from '../firebase';

export const addAlbum = async (data) => {
	return await addDocument('albums', data);
};

export const addArtist = async (data) => {
	return await addDocument('artists', data);
};

export const addFeature = async (data) => {
	return await addDocument('features', data);
};

export const addLabel = async (data) => {
	return await addDocument('labels', data);
};

export const addGenre = async (data) => {
	return await addDocument('genres', data);
};

export const editPage = async (data) => {
	return await addDocument('pages', data);
};

export const getFeature = async (id) => {
	return await getDocumentData('features', id);
};

export const getPage = async (id) => {
	return await getDocumentData('pages', id);
};

export const getAlbumReviews = async (albumId) => {
	return await getCollection(`albums/${albumId}/reviews`);
}

export const getAlbums = async (limit, start) => {
	let query = {orderBy: ['reviewDate', 'desc'], limit: (limit || 20)};
	if (start) {
		query.startAfter = start;
	}
	return await getCollection('albums', query);
}

export const getFeatures = async (limit, start) => {
	let query = {orderBy: ['publishDate', 'desc'], limit: (limit || 20)};
	if (start) {
		query.startAfter = start;
	}
	return await getCollection('features', query);
}

export const getApprovedFeatures = async (limit, start) => {
	let query = {orderBy: ['publishDate', 'desc'], limit: (limit || 20)};

	if (start) {
		query.startAfter = start;
	}
	console.log('getting features');
	try {
		return await getCollection('features', query);
	} catch (e) {
		console.error(e);
	}
	return null;
}

export const getUsers = async (limit, start) => {
	return await getCollection('users', {limit: 25});
}

export const getRecentAlbums = async (limit, start) => {
	let query = {orderBy: ['reviewDate', 'desc'], limit: (limit || 20), where: [['status', 'array-contains', 'approved']]};
	if (start) {
		query.startAfter = start;
	}
	return await getCollection('albums', query);
};

export const getPendingAlbums = async () => {
	const pendingAlbumsCollection = await getCollection('albums', {orderBy: ['reviewDate', 'desc'], limit: 10, where: [['status', 'array-contains', 'pending']]});
	return pendingAlbumsCollection.data;
};

export const getRecentUserReviews = async (userId) => {
	const recentUserReviews = await getCollection('albums', {limit: 20, where: [[`reviews.${userId}.id`, '==', userId]]});
	return recentUserReviews.data;
};
